import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    loading: {
      marginTop: theme.spacing(10),
      display: "flex",
      justifyContent: "center",
      alignContent: "center"
    },
    section: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down("xs")]: {
        margin: theme.spacing(2)
      }
    },
    trailing: {
      marginBottom: theme.spacing(2)
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2),
      maxWidth: "500px",

      [theme.breakpoints.down("xs")]: {
        width: "100%",
        maxWidth: "100%"
      }
    },
    minimum500: {
      minWidth: "500px",

      [theme.breakpoints.down("xs")]: {
        minWidth: "100%"
      }
    }
  })
);
